import FallbackLoader from '../FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-CercacasaChannelDialog" */'@modals/partials/cerca-casa/ChannelDialog'));
